import { template as template_67237f9aca00438d893f8d4b80703a7a } from "@ember/template-compiler";
import { registerDestructor } from '@ember/destroyable';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import OnDocumentVisibility from 'client-portal/modifiers/on-document-visibility';
// SPDS Modal pulls in dialog-polyfill, which crashes FastBoot (no HTMLElement).
// Keep that import out of the billing route template's static graph.
export default class SiteBillingTransferSetupModalHost extends Component {
    @service
    billingTransfer;
    @service
    fastboot;
    @tracked
    Modal = null;
    constructor(){
        super(...arguments);
        if (this.fastboot.isFastBoot) {
            return;
        }
        let cancelled = false;
        registerDestructor(this, ()=>{
            cancelled = true;
        });
        this.#loadModal(()=>cancelled);
    }
    async #loadModal(isCancelled) {
        let mod = await import('./transfer-setup-modal');
        if (!isCancelled()) {
            this.Modal = mod.default;
        }
    }
    static{
        template_67237f9aca00438d893f8d4b80703a7a(`
    {{#if this.billingTransfer.isPendingTransfer}}
      <div
        hidden
        data-test-billing-transfer-visibility-watcher
        {{OnDocumentVisibility this.billingTransfer.onDocumentVisible}}
      ></div>
    {{/if}}

    {{#if this.billingTransfer.isModalOpen}}
      {{#if this.Modal}}
        <this.Modal />
      {{/if}}
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
